"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _Ripple = _interopRequireDefault(require("../Ripple"));
var _selectors = require("../../shared/styles/themes/selectors");
var _styles = require("./styles");
var _props = require("./props");
var _excluded = ["children", "disabled", "loading", "onClick", "type", "size", "labelIcon", "rounded"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Children = function Children(_ref) {
  var component = _ref.component,
    size = _ref.size;
  return component ? /*#__PURE__*/(0, _react.cloneElement)(component, {
    width: _props.buttonSizes[size].height,
    height: _props.buttonSizes[size].height
  }) : null;
};
var LabelIcon = function LabelIcon(_ref2) {
  var component = _ref2.component,
    size = _ref2.size;
  return component ? /*#__PURE__*/(0, _react.cloneElement)(component, {
    width: _props.buttonSizes[size].labelIcon,
    height: _props.buttonSizes[size].labelIcon
  }) : null;
};
var ButtonSimple = function ButtonSimple(_ref3) {
  var children = _ref3.children,
    disabled = _ref3.disabled,
    loading = _ref3.loading,
    onClick = _ref3.onClick,
    type = _ref3.type,
    size = _ref3.size,
    labelIcon = _ref3.labelIcon,
    rounded = _ref3.rounded,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var handleOnClick = function handleOnClick() {
    if (!disabled && !loading && (0, _isFunction["default"])(onClick)) {
      onClick();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.ButtonStyle, _extends({
    onClick: handleOnClick,
    type: type,
    size: size,
    rounded: rounded
  }, _objectSpread({
    disabled: disabled
  }, rest)), !disabled && !loading && /*#__PURE__*/_react["default"].createElement(_Ripple["default"], {
    color: (0, _selectors.getField)('button.ripple', rest)
  }), loading ? /*#__PURE__*/_react["default"].createElement(_styles.Loader, _extends({
    colorType: rest.colorType
  }, rest)) : /*#__PURE__*/_react["default"].createElement(Children, {
    component: children,
    size: size
  }), labelIcon && /*#__PURE__*/_react["default"].createElement(_styles.LabelIconWrapper, _extends({
    size: size,
    rounded: rounded
  }, rest), /*#__PURE__*/_react["default"].createElement(LabelIcon, {
    component: labelIcon,
    size: size
  })));
};
ButtonSimple.propTypes = {
  children: _propTypes["default"].node,
  labelIcon: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  rounded: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  type: _propTypes["default"].string,
  size: _propTypes["default"].string
};
ButtonSimple.defaultProps = {
  size: 's'
};
var _default = exports["default"] = (0, _styledComponents.withTheme)(ButtonSimple);